import React from 'react';
import { AvButton } from '@fabric-ui/components';
import useSalesforceSupportPortal from '@hooks/useSalesforceSupportPortal';
import { useAvContext } from '../../context/AvContextProvider';

const CopilotSendFeedback = () => {
  const { selectedApp, api } = useAvContext();
  const openSalesforcePortal = useSalesforceSupportPortal({ api, currentApp: selectedApp });

  return (
    <AvButton size="xSmall" sx={{ p: 0, fontSize: 12 }} onClick={openSalesforcePortal}>
      Submit feedback
    </AvButton>
  );
};

export default CopilotSendFeedback;
